/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, ReactNode, Component } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Material Dashboard 2 PRO React TS Base Styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
//import backgroundImage from "assets/images/bg-profile.jpeg";
import backgroundImage from "assets/images/bg-profile2.jpeg";
import _ from "lodash";

class HeaderClass extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      tabsOrientation: "horizontal",
      tabValue: 0,
    };
  }
  setTabValue(value: number) {
    this.setState({ tabValue: value });
  }
  handleSetTabValue = (event: any, newValue: any) => this.setTabValue(newValue);

  renderTab() {
    const { tabsOrientation, tabValue } = this.state as any;
    const { tabs } = this.props as any;

    let Draw: any = [];
    _.map(tabs, (v, k) => {
      Draw.push(
        <Tab
          label={v}
          icon={
            <Icon fontSize="small" sx={{ mt: -0.25 }}>
              home
            </Icon>
          }
        />
      );
    });

    return (
      <Grid item xs={12} md={6} lg={6} sx={{ ml: "auto" }}>
        <AppBar position="static">
          <Tabs orientation={tabsOrientation} value={tabValue} onChange={this.handleSetTabValue}>
            {Draw}
          </Tabs>
        </AppBar>
      </Grid>
    );
  }

  render(): ReactNode {
    const { children, tabs, userProfile } = this.props as any;

    return (
      <MDBox position="relative" mb={5}>
        <MDBox
          display="flex"
          alignItems="center"
          position="relative"
          minHeight="18.75rem"
          borderRadius="xl"
          sx={{
            backgroundImage: `url(${backgroundImage})`,
            // ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            //   `${linearGradient()
            //   rgba(gradients.info.main, 0.6),
            //   rgba(gradients.info.state, 0.6),
            //   }, url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "100%",
            overflow: "hidden",
          }}
        />
        <Card
          sx={{
            position: "relative",
            mt: -8,
            mx: 3,
            py: 2,
            px: 2,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item>
              <MDAvatar
                src={userProfile.imageUrl}
                alt="profile-image"
                size="xl"
                shadow="sm"
                bgColor={userProfile.imageUrl ? "transparent" : "info"}
              >
                {!userProfile.imageUrl && userProfile.firstLetter}
              </MDAvatar>
            </Grid>
            <Grid item>
              <MDBox height="100%" mt={0.5} lineHeight={1}>
                <MDTypography variant="h5" fontWeight="medium">
                  {userProfile.nickName}
                </MDTypography>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  {userProfile.role}
                </MDTypography>
              </MDBox>
            </Grid>
            {_.size(tabs) > 0 && this.renderTab()}
          </Grid>
          {children}
        </Card>
      </MDBox>
    );
  }
}

function Header(props: any) {
  return <HeaderClass {...props} />;
}

Header.defaultProps = {
  tabs: [],
  userProfile: {},
};
export default Header;
